import Swiper from 'swiper/bundle';
import {x, x0} from '../_helpers';

export default class Slider {
    constructor() {
        this.init();
    }

    update() {
        this.slider.update();
    }

    init() {
        this.slider = new Swiper (x0('[js-slider]'), {
            loop: true,
            speed: 1300,
            slidesPerView: 1,
            observer: true,
            observeParents: true,
            touchMultiplier: 3,
            autoplay: {
                delay: 1500,
                disableOnInteraction: false
            }
        });
    }
}